<template>
    <div :class="isFloat?'float-Box-Active':''" style="border: 3px solid #23d3ee;border-radius: 5px" >

        <div id="search-box" class="search-box active-layer search-cursor" @click="searchScroll" >
            <div class="input-box address" ref="keyRef" >
                <i class="iconfont icon-search"></i>
                <input type="text" maxlength="50" autocomplete="off"  style="vertical-align: middle;" v-model="keyVal" placeholder="酒店名称/城市/景点/关键词" @click="openCity($event)" @keyup="input()" id="keyRef" ref="keyInput">
                <i class="iconfont icon-guanbi text-close-btn" @click="keyVal=''" v-if="keyVal"></i>
            </div>

            <div class="input-box date" @click="openDate()" id="dateRef">
                <i class="iconfont icon-calendar"></i>
                {{CheckIn}}
                <span>{{getDays(CheckIn,CheckOut)}}晚</span>
                {{CheckOut}}
            </div>

            <div class="input-box room">
                <i class="iconfont icon-room"></i>
                <div @click="openRoomCount()">
                    <div>{{RoomCountVal}}间</div>
                </div>
                <roomCount @select="selectCount" :isRoomCountShow = "isRoomCountShow"></roomCount>
            </div>

            <div class="input-box people" @click="openRoom()">
                <i class="iconfont icon-renshu"></i>
                {{AdultCount}}成人/{{ChildrenCount}}儿童
            </div>

            <div class="input-box room nation">
                <i class="iconfont icon-guoji" style="font-size: 24px"></i>
                <div @click="openCountry()">
                    {{Nationality.CNName}}
                </div>
                <country @select="selectCountry" :isCountryShow="isCountryShow"></country>
            </div>

            <div class="search-btn" @click="submit">搜索</div>

        </div>
        <div class="details-cmp-box"  >
            <div class="close-layer" @click="close" v-show="isLayerShow"></div>
            <HotCity @select="selectHotCity"  :isHotCityShow="isHotCityShow" v-if="ProductType==4"></HotCity>
            <HsHotCity @select="selectHotCity" :productType="ProductType" :isHotCityShow="isHotCityShow" v-else></HsHotCity>

            <SearchAll :keyword="keyVal" :productType="ProductType" :isKeyResultShow="isKeyResultShow" @selectCity="selectCity" @selectHotel="selectHotel" @selectLandmark="selectLandmark"></SearchAll>

            <DatePicker  @select="calendarSelect" :calendarShow="calendarShow" :start="calendarStart"  :beginDate="CheckIn" :endDate="CheckOut"></DatePicker>

            <Room :AdultCount="AdultCount" :ChildrenCount="ChildrenCount" :ChildrenAges="ChildrenAges" @select="selectRoomPeopelNum" :isRoomShow="isRoomShow"></Room>
        </div>
    </div>

</template>
<script>
    import DatePicker from './../datePicker/date.vue'//日期
    import SearchAll from './all'//模糊搜索
    import HotCity from './city' //热门城市
    import roomCount from './roomCount' //选择房间数
    import country from './country' //选择国籍
    import HsHotCity from './../hotCity/HotCity' //名宿热门城市
    import Room from './room'//选择每间房间的住客数
    export default{
        name:'searchBox',
        components:{
            DatePicker,
            SearchAll,
            HotCity,
            HsHotCity,
            Room,
            roomCount,
            country
        },
        props:{
            Country:{
                type:Object,
                default:{
                    "Code2": "CN",
                    "Code3": "CHN",
                    "Num": "156",
                    "Iso": "ISO 3166-2:CN",
                    "ENName": "China",
                    "CNName": "中国大陆"
                },
            },
            AdultCount:{
                type:Number,
                default:2,
            },
            ChildrenCount:{
                type:Number,
                default:1,
            },
            ChildrenAges:{
                type:Array,
                default:[],
            },
            CheckIn:{
                type:String,
                default:'',
            },
            keys:{
                type:String,
                default:'',
            },
            CheckOut:{
                type:String,
                default:'',
            },
            RoomCount:{
                type:Number,
                default:1,
            },
            isFloat:{
                type:Boolean,
                default:false,
            },
            ProductType:{
                type:String,
                default:'4',
            },
        },
        data(){
            return{
                keyVal:'',
                Nationality:{
                    "Code2": "CN",
                    "Code3": "CHN",
                    "Num": "156",
                    "Iso": "ISO 3166-2:CN",
                    "ENName": "China",
                    "CNName": "中国大陆"
                },
                isLayerShow:false,
                RoomCountVal:1,
                isKeyResultShow:false,
                isRoomShow:false,
                isRoomCountShow:false,
                isHotCityShow:false,
                calendarShow:false,
                isCountryShow:false,
                calendarStart:this.getDate(0)
            }
        },
        watch:{
            keyVal(val){
                this.$refs.keyRef.style.border="none";
            },
            keys(val) {
                this.keyVal=this.keys;
            }
        },
        methods:{
            //滚动动画
            scrollAnimation(currentY, targetY) {
                let needScrollTop = targetY - currentY;
                let _currentY = currentY;
                setTimeout(() => {
                    const dist = Math.ceil(needScrollTop / 10)
                    _currentY += dist
                    window.scrollTo(_currentY, currentY)
                    if (needScrollTop > 10 || needScrollTop < -10) {
                        this.scrollAnimation(_currentY, targetY)
                    } else {
                        window.scrollTo(_currentY, targetY)
                    }
                }, 1)
            },
            searchScroll(e) {
               
                var offsetTop1 = document.querySelector('#mapAndHistory') ? document.querySelector('#mapAndHistory').offsetTop : 0;
                var offsetTop2 = document.querySelector('#searchBoxDiv') ? document.querySelector('#searchBoxDiv').offsetTop : 0;
                var offsetTop=offsetTop1||offsetTop2;
             
                var currentY = document.documentElement.scrollTop || document.body.scrollTop
                if (currentY < offsetTop) {
                    this.scrollAnimation(currentY, offsetTop)
                }
            },
            input(){
               
                this.close();
                this.isKeyResultShow=true;
                this.isLayerShow=true;
            },
            //打开城市
            openCity(event){
                this.close();
                this.isHotCityShow=true;
                this.isLayerShow=true;

                event.currentTarget.select();
            },
            //打开模糊搜索
            openAll(){

                this.close();
                this.isKeyResultShow=true;
                this.isLayerShow=true;
            },
            //打开日期
            openDate(){
                this.close();
                this.calendarShow=true;
                this.isLayerShow=true;
            },
            //打开日期
            openRoom(){
                this.close();
                this.isRoomShow=true;
                this.isLayerShow=true;
            },
            //打开国籍
            openCountry(){
                this.close();
                this.isCountryShow=true;
                this.isLayerShow=true;
            },
            //选择房间数
            openRoomCount(){
                this.close();
                this.isRoomCountShow=true;
                this.isLayerShow=true;
            },
            //关闭所有弹窗
            close(){

                this.isRoomShow = false;
                this.isHotCityShow = false;
                this.calendarShow = false;
                this.isKeyResultShow = false;
                this.isLayerShow = false;
                this.isRoomCountShow=false;
                this.isCountryShow = false;
            },
            //客人住房数
            selectRoomPeopelNum(Adult, Children, ages) {

                if(!Adult)return;
                if(Adult=='close'){
                    this.close();
                    return;
                }
                this.close();
                this.$emit('selectRoomPeopelNum',Adult, Children, ages);
            },
            //房间数
            selectCount(val){
                if (!val) return;

                this.close();
                this.RoomCountVal = val;
                this.$emit('selectRoomCount',val);
            },
            selectCountry(obj){
                if (!obj) return;
                this.close();
                this.Nationality = obj;
                this.$emit('selectCountry',obj);
            },
            selectHotCity(val) {
                if (!val) return;
                var val={
                    CName:val.N,
                    From: val.F,
                    ID:val.I
                }
                this.keyVal=val.CName;
                this.close();
                this.$emit('selectCity',val);
            },
            selectCity(val){
                this.close();
                this.$emit('selectCity',val);
                this.keyVal=val.SName;
            },
            selectHotel(val){
                this.close();
                this.$emit('selectHotel',val);
                this.keyVal=val.Name;
            },
            selectLandmark(val){
                this.close();
                this.$emit('selectLandmark',val);
                this.keyVal=val.Name;
            },
            calendarSelect(begin,end){
                this.close();
                this.$emit('calendarSelect',begin,end)
            },
            submit(){
                //若没有选择城市或者地标，则显示提示框提醒
                if(!this.keyVal){
                    const el = this.$refs.keyRef;
                    el.style.border="1px solid red";
                    el.classList.add("blink-border");
                    this.$refs.keyInput.focus();
                    el.addEventListener('animationend', () => el.classList.remove('blink-border'), {once:true});
                    // this.error({title: '提示', content: '请输入酒店名称/城市/景点/关键字！'});

                    return;
                }
                this.$emit('submit')
            }
        },
        mounted(){
            this.keyVal=this.keys;
            this.RoomCountVal=this.RoomCount;
            this.Nationality = this.Country;
        }
    }
</script>


// WEBPACK FOOTER //
// src/common/cmpnt/searchBox/searchBox.vue